import { Column, Row } from '../../components'
import ViewCustomerResults from './ViewCustomerResults'
import CustomerAdvancedSearch from './CustomerAdvancedSearch'
import CustomerFilterRequest from '../model/CustomerFilterRequest'
import React, { useState, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useDispatch } from 'react-redux'
import { showGridContext } from './CustomerFilter'
import { resetCustomerSliderState } from '../customer-slider-content/CustomerSliderContext'
import { setCustomerSummary, storeCustomerPolicies, updateCustomers, updateSelectedPolicyDetails } from '../customer-slice/Customer-slice'
import { updateNoteList } from '../customer-slice/Customer-note-slice'

const customerAdvancedSearch = () => {
  const initalFilterState: CustomerFilterRequest = {
    firstName: '',
    lastName: '',
    eMail: '',
    homePhone: '',
    address1: '',
    address2: '',
    city: '',
    zipCode: '',
    state: '',
    isPropertySearch: true,
    custNumber: null,
    policyNumber: '',
    countryId: '',
    PolicyTypeId: '',
    PolEffDate: null,
    CompanyId: '',
    WritingCompanyId: ''
  }

  const [GridContext, setGridContext] = useState({
    IsGridVisible: true,
    FilterData: initalFilterState
  })
  const [showGrid, setShowGrid] = useState(GridContext.IsGridVisible)
  const [searchfilter, setInputFilter] = useState<CustomerFilterRequest>(GridContext.FilterData)
  const [searchResult, setsearchResult] = useState([])
  const dispatch = useDispatch()

  const clearCustomerRelatedDataFromStore = () => {
    dispatch(resetCustomerSliderState())
    dispatch(updateCustomers({} as any))
    dispatch(storeCustomerPolicies([]))
    dispatch(updateSelectedPolicyDetails({ policyId: '', polEventId: '', policyDetails: null }))
    dispatch(updateNoteList([]))
    dispatch(setCustomerSummary(null as any))
  }

  useEffect(() => {
    clearCustomerRelatedDataFromStore()
  }, [])

  const FallbackComponent = ({ error, resetErrorBoundary }: any) => {
    console.log('An error occurred:')
    console.log(error.message)
    return (
      <div>
        <h1>An error occurred: {error.message}</h1>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    )
  }

  return (
    <showGridContext.Provider value={{ GridVisibility: [showGrid, setShowGrid], InputFilter: [searchfilter, setInputFilter], searchResultData: { searchResult, setsearchResult } } as any}>
      <div>
        <Row>
          <Column md={12} lg={12}>
            <ErrorBoundary FallbackComponent={FallbackComponent}>
              <CustomerAdvancedSearch />
            </ErrorBoundary>
          </Column>
        </Row>

        <Row>
          <Column md={12} lg={12} className='cstTable'>
            <ErrorBoundary FallbackComponent={FallbackComponent}>
              {searchResult && searchResult.length > 0 && <ViewCustomerResults filterRequest={searchfilter} />}
              <br />
            </ErrorBoundary>
          </Column>
        </Row>
      </div>
    </showGridContext.Provider>
  )
}

export default customerAdvancedSearch
